import * as types from './mutation-type';

const mutations = {
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.SET_COURSE_LIST](state, list) {
    state.courseList = list;
  },
  [types.SET_ACTIVITY_LIST](state, list) {
    state.activityList = list;
  },
  [types.SET_ACTIVITY_COURSE_LIST](state, list) {
    state.activityCourseList = list;
  },
  [types.SET_SCHOOL_LIST](state, list) {
    state.schoolList = list;
  },
  [types.SET_COACH_LIST](state, list) {
    state.coachList = list;
  },
  [types.SET_ORDER_LIST](state, list) {
    state.orderList = list;
  },
  [types.SET_UPLOAD_COACH_LIST](state, list) {
    state.uploadCoachList = list;
  },
  [types.SET_STOCK_LIST](state, list) {
    state.stockList = list;
  },
  [types.SET_STUDENT_LIST](state, list) {
    state.studentList = list;
  },
  [types.SET_CERT_LIST](state, list) {
    state.certList = list;
  },
  [types.SET_COURSE](state, course) {
    state.course = course;
  },
  [types.SET_SCHOOL](state, school) {
    state.school = school;
  },
  [types.SET_COACH](state, coach) {
    state.coach = coach;
  },
  [types.SET_CERT](state, cert) {
    state.cert = cert;
  },
};

export default mutations;
